import React, { useState, useEffect, useReducer, useRef } from "react";
import { useSelector } from "react-redux";
import _, { isEmpty } from "lodash";

import ScrollView from "devextreme-react/scroll-view";
import sa3 from "../../reducers/sa3";

import { FileUploader, DateBox, RadioGroup } from "devextreme-react";
import "../../styles/sps.css";
import SaveButton from "devextreme-react/button";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { TagBox } from "devextreme-react";
import { alert, confirm } from "devextreme/ui/dialog";
import * as actions from "../../actions/sa3";
import ResultChart from "./ResultChart";
import { onDownloadFile } from "../../common/utils";
import { postUserLog } from "../../actions/common";
import {
  searchValueByOneProperty,
  isDuplicatesByOneProperty,
} from "../settings/utils";

import DataGrid, {
  Column,
  Paging,
  Toolbar,
  Item,
  SearchPanel
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialStates = {
  peopleList: [],
  userDetails: [],
};

const initialState = {
  confirmedResultsData: null,
  confirmedResultsGraphData: null,
};

const ConfirmedResult = (props) => {
  const [state, dispatch] = useReducer(sa3, initialState);
  let {
    confirmedResultsData,
    attachmentsA3,
    confirmedResultsGraphData,
    strategicA3Data,
  } = state;
  const [gridData, setgridData] = useState([]);
  const [gridKeys, setgridKeys] = useState([]);
  const [dropdown, setdropdown] = useState([]);
  const [image, setImage] = useState();
  const [selectedVal, setselectedVal] = useState([]);
  const productLabel = { "aria-label": "KPI" };
  const [runChartdata, setrunChartdata] = useState([]);
  const dataGridRef = useRef(null);
  const [startDate, setstartDate] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [endDate, setendDate] = useState("");
  const [frequency, setfrequency] = useState("");
  const [enable, setenable] = useState(false);
 
  //Initial API Calls for Box 8 to Load
  useEffect(() => {
    actions.fetchConfirmedResults(dispatch, props.a3ID);
    actions.fetchConfirmedResultsGraph(dispatch, props.a3ID);
    actions.GetAttachmentsDataA3(dispatch, props.a3ID, "Results");
    actions.fetchData(dispatch, props.a3ID);
  }, []);

  useEffect(() => {
    setstartDate(strategicA3Data?.resultStartDate);
    setendDate(strategicA3Data?.resultEndDate);
    setfrequency(strategicA3Data?.resultFrequency);
    setenable(!isEmpty(strategicA3Data?.resultStartDate));
  }, [strategicA3Data]);

  //grid data and Graph data structure is modified as per the need
  // it takes care of filters that are previously applied
  //dropdown list values are also taken care
  useEffect(() => {
    // setgrid2Data(confirmedResultsData);
    if (!isEmpty(confirmedResultsData)) {
      const groupedData = confirmedResultsData?.reduce(
        (result, item) => {
          const existingGroup = result.find(
            (group) => group.KPIStateID === item.KPIStateID
          );

          if (existingGroup) {
            existingGroup.TableVal.push(item);
          } else {
            result.push({
              A3ID: item.A3ID,
              KPIStateID: item.KPIStateID,
              KPIStateName: item.KPIStateName,
              TableVal: [item],
            });
          }

          return result;
        },
        [confirmedResultsData]
      );

      const newData = groupedData?.map((group) => ({
        A3ID: group.A3ID,
        KPIStateID: group.KPIStateID,
        KPIStateName: group.KPIStateName,
        TableVal: group.TableVal,
      }));
      const uniqueKPIStates = [
        ...new Set(confirmedResultsData.map((item) => item.KPIStateName)),
      ];
      const dropdownval =
        selectedVal.length == 0 ? uniqueKPIStates : selectedVal;

      const filteredData = newData.filter((item) =>
        dropdownval.includes(item.KPIStateName)
      );
      setgridData(filteredData);

      setdropdown(uniqueKPIStates);
    }
  }, [confirmedResultsData]);
  useEffect(() => {
    if (!isEmpty(confirmedResultsGraphData) && confirmedResultsData !== null) {
      graphDataModify();
    }
  }, [confirmedResultsGraphData]);
  const graphDataModify = () => {
    const modifiedObj = {};
    confirmedResultsGraphData.forEach((item) => {
      const { kpiStateName, resultDate, target, actual, baseline, aop } = item;

      if (!modifiedObj[kpiStateName]) {
        modifiedObj[kpiStateName] = { kpiStateName, chartData: [] };
      }

      modifiedObj[kpiStateName].chartData.push({
        resultDate,
        target,
        actual,
        baseline,
        aop,
      });
    });

    const runChartData = Object.values(modifiedObj);
    const uniqueKPIStates = [
      ...new Set(confirmedResultsData?.map((item) => item.KPIStateName)),
    ];
    const dropdownval = selectedVal.length == 0 ? uniqueKPIStates : selectedVal;

    const filteredGraphData = runChartData.filter((item) =>
      dropdownval.includes(item.kpiStateName)
    );
    setrunChartdata(filteredGraphData);
  };

  const initialstateConfig = {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,

    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    sorting: {
      mode: "row",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    // searchPanel: {
    //   visible: true,
    // },
    // paging: {
    //   pageSize: 10,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },

    export: {
      enabled: true,
      fileName: "Initial_State",
    },
    editing: {
      mode: "cell",
      allowUpdating: true,
    },
  };

  const onRowUpdated = (e) => {
    // setenableadd(true);
    if (strategicA3Data?.status != "Complete") {
      let data = e.data;
      data.section = props.activeTab;
      data.siteId = props.siteId;
      data.tierId = props.tierId;
        actions.manageResults(dispatch, [data]);
    } else {
      alert("This A3 is Completed, can't make changes", "Alert");
    }
  };

  const onRowInserted = () => {
    // setenableadd(true);
  };
  const handlers = {
    onRowUpdated: onRowUpdated,
    onRowInserted: onRowInserted,
  };

  //filter data on dropdown selection of KPI
  const onValueChange = (e) => {
    const searchWords = e;
    setselectedVal(searchWords);
    if (!isEmpty(confirmedResultsGraphData)) {
      const modifiedObj = {};

      confirmedResultsGraphData.forEach((item) => {
        const { kpiStateName, resultDate, target, actual, baseline, aop } =
          item;

        if (!modifiedObj[kpiStateName]) {
          modifiedObj[kpiStateName] = { kpiStateName, chartData: [] };
        }

        modifiedObj[kpiStateName].chartData.push({
          resultDate,
          target,
          actual,
          baseline,
          aop,
        });
      });

      const runChartData = Object.values(modifiedObj);
      const filteredGraphData = runChartData.filter((item) =>
        searchWords.includes(item.kpiStateName)
      );
      setrunChartdata(filteredGraphData);
    }
    if (!isEmpty(confirmedResultsData)) {
    
      const groupedData = confirmedResultsData?.reduce(
        (result, item) => {
          const existingGroup = result.find(
            (group) => group.KPIStateID === item.KPIStateID
          );

          if (existingGroup) {
            existingGroup.TableVal.push(item);
          } else {
            result.push({
              A3ID: item.A3ID,
              KPIStateID: item.KPIStateID,
              KPIStateName: item.KPIStateName,
              TableVal: [item],
              section: props.activeTab,
              siteId: props.siteId,
              tierId: props.tierId,
            });
          }

          return result;
        },
        [confirmedResultsData]
      );

      const newData = groupedData?.map((group) => ({
        A3ID: group.A3ID,
        KPIStateID: group.KPIStateID,
        KPIStateName: group.KPIStateName,
        TableVal: group.TableVal,
        section: props.activeTab,
        tierId :props.tierId,
      }));

      const filteredData = newData.filter((item) =>
        searchWords.includes(item.KPIStateName)
      );
      setgridData(filteredData);
    }
  };

  //save frequency data on button click
  const saveConfirmedResults = () => {
    if (strategicA3Data?.resultStartDate == null) {
      const data = {
        startDate: startDate,
        endDate: endDate,
        frequency: frequency,
        a3ID: props.a3ID,
        section: props.activeTab,
        siteId: props.siteId,
        tierId: props.tierId,
      };
      if ((startDate != null) & (endDate != null)) {
        if (endDate > startDate) {
          let confirm_it = confirm(
            "Frequency once saved cannot be changed",
            "Please Confirm"
          );
          confirm_it.then((res) => {
            if (res) {
              actions.manageFrequencyResults(dispatch, data);
              props.handleA3Save();
              props.setisOpen("8");
            }
          });
        } else {
          alert("End date Should be greater than Start Date", "Alert");
        }
      } else {
        alert("Start Date and End Date are required Fields", "Alert");
      }
    }
    //for attachments
    if (selectedFiles?.length > 0) {
      let formData = new FormData();

      const validateUploadFiles = checkUploadFilesValid(
        selectedFiles,
        ALLOWED_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );
        alert(alertMsg.join("<br/>"), "Alert");
        return false;
      }

      if (
        selectedFiles &&
        selectedFiles.length &&
        Array.isArray(selectedFiles)
      ) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
        });
      }
      formData.append("A3Id", props.a3ID);
      formData.append("TierID", props.tierId);
      formData.append("attachmentType", "Results");
      formData.append("activeTab", props.activeTab);
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_ATTACHMENT_A3,
        NEXUS_CONST.PUT,
        formData
      ).then((res) => {
        // setEanbleSave(false);
        // dispatch({ type: ACTION_TYPES.RCA_ATTACHMENT, payload: res.data });
        actions.GetAttachmentsDataA3(dispatch, props.a3ID, "Results");
        setSelectedFiles([]);
      });
    }
  };

  //Attachments related function
  //files attachments handling
  const onFileSelect = (e) => {
    setSelectedFiles(e.value);

    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };
  const deleteFile = (id, attachmentName) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      actions.deleteAttachmentA3(
        dispatch, 
        id, 
        props.a3ID, 
        "Results", 
        attachmentName, 
        props.tierId, 
        props.activeTab
        );
    });
  };

  //save attachemnt
  const saveAttachment = () => {
    if (selectedFiles?.length > 0) {
      let formData = new FormData();

      if (
        selectedFiles &&
        selectedFiles.length &&
        Array.isArray(selectedFiles)
      ) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
        });
      }
      formData.append("A3Id", props.a3ID);
      formData.append("TierID", props.tierId);
      formData.append("attachmentType", "Results");
      formData.append("activeTab", props.activeTab);
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_ATTACHMENT_A3,
        NEXUS_CONST.PUT,
        formData
      ).then((res) => {
        // setEanbleSave(false);
        // dispatch({ type: ACTION_TYPES.RCA_ATTACHMENT, payload: res.data });
        actions.GetAttachmentsDataA3(dispatch, props.a3ID, "Results");
        setSelectedFiles([]);
      });
    }
  };

  return (
    <>
      <div className="title-section ">
        {" "}
        <h2 className="sps_title">Confirmed results</h2>{" "}
        <div className="sps-save-btn save-btn">
          <SaveButton
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            // disabled={enable}
            width={200}
            onClick={saveConfirmedResults}
            text="Save"
            type="normal"
          />
        </div>
      </div>

      <ScrollView width="100%" height="434px" className="sps-box-s">
        <div style={{ display: "flex", marginTop: "5px" }}>
          <DateBox
            value={startDate}
            onValueChanged={(e) => setstartDate(e.value)}
            useMaskBehavior={true}
            label="Start Date"
            type="date"
            width={200}
            height={40}
            disabled={enable}
          />
          <DateBox
            value={endDate}
            onValueChanged={(e) => setendDate(e.value)}
            useMaskBehavior={true}
            type="date"
            label="End Date"
            width={200}
            height={40}
            disabled={enable}
          />
          <RadioGroup
            items={[
              { id: "M", text: "Monthly" },
              { id: "W", text: "Weekly" },
            ]}
            value={frequency == "Weekly" ? "W" : "M"}
            valueExpr="id"
            displayExpr="text"
            layout="horizontal"
            disabled={enable}
            onValueChanged={(e) =>
              setfrequency(e.value == "W" ? "Weekly" : "Monthly")
            }
          />
          {confirmedResultsData && dropdown != [] ? (
            <TagBox
              items={dropdown}
              label="Select KPI"
              showSelectionControls={true}
              defaultValue={[
                ...new Set(
                  confirmedResultsData?.map((item) => item.KPIStateName)
                ),
              ]}
              onValueChange={onValueChange}
              width={500}
              style={{ position: "relative", left: "275px" }}
            />
          ) : (
            ""
          )}
        </div>
        <div style={{ display: "flex" }}>
          <div className="a3resultsgrid">
            {gridData?.map((item) =>
              item.A3ID != undefined ? (
                <div
                  style={{
                    width: "500px",
                    minHeight: "440px",
                  }}
                >
                  <DataGrid
                    style={{
                      paddingTop: "10px",
                      paddingRight: "20px",
                      width: "60% !important",
                    }}
                    // ref={dataGridRef}
                    dataSource={item.TableVal}
                    allowColumnReordering={true}
                    showBorders={true}
                    onExporting={() =>
                      postUserLog({
                        event: `Box 8 - Confirmed Result Export`,
                        data: {
                          action: `Confirmed Result exported for A3-${props.a3ID}`,
                          module: "Digital Tier",
                          section: props.activeTab,
                          siteUId: props.siteId,
                          widget: "Strategic A3",
                          tierId: props.tierId,
                        },
                      })
                    }
                    {...initialstateConfig}
                    {...handlers}
                    wordWrapEnabled={true}
                    width={"100%"}
                    height={"400px"}
                  >
                    <Toolbar>
                      <Item location="before">
                        <div className="informer">
                          <span className="name">{item.KPIStateName}</span>
                        </div>
                      </Item>
                      <Item name="searchPanel" visible={true} />
                    </Toolbar>
                    <Paging enabled={false} visible={false} />
                    <SearchPanel
                        visible={true}
                        onTextChange={(e) => {
                          if (!isEmpty(e)) {
                            postUserLog({
                              event: "Box 8 - Confirmed Result Grid Search",
                              data: {
                                action: `${e} searched in confirmed result grid A3-${props.a3ID}`,
                                module: "Digital Tier",
                                section: props.activeTab,
                                siteUId: props.siteId,
                                widget: "Strategic A3",
                                tierId: props.tierId,
                              },
                            });
                          }
                        }}
                      />
                    <Column
                      dataField="ResultDate"
                      caption="Result Date"
                      allowFiltering={false}
                      width={150}
                      allowEditing={false}
                    ></Column>
                    <Column
                      dataField="AOP"
                      caption="AOP"
                      allowFiltering={false}
                      width={150}
                    ></Column>
                    <Column
                      dataField="Actual"
                      caption="Actual"
                      allowFiltering={false}
                      width={100}
                    ></Column>
                  </DataGrid>
                </div>
              ) : (
                ""
              )
            )}
          </div>
          <div>
            {confirmedResultsGraphData &&
              runChartdata.map((item) => (
                <div style={{ width: "900px", minHeight: "440px" }}>
                  <ResultChart runChartdata={item}></ResultChart>
                </div>
              ))}
          </div>
        </div>
        {/* Attachments */}
        <div style={{ width: "100%", marginBottom: "50px" }}>
          <div className="dx-field no-print">
            <div className="dx-field-label">Confirmed Results Attachment</div>

            <FileUploader
              className="dx-field-value gridavailable"
              selectButtonText="Choose file"
              labelText="Max. File Size 4 MB"
              accept="*"
              uploadMode="uploadUrl"
              multiple={true}
              onValueChanged={onFileSelect}
              value={selectedFiles}
              allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
            />
            {/* <Button style={{ position: "relative", right: "350px" }}>
              <i
                className="fas fa-save fa-lg"
                title="Save Attachment"
                // onClick={saveAttachment}
              />{" "}
            </Button> */}
          </div>
          {attachmentsA3 &&
            attachmentsA3.map((item) => (
              <div>
                <a
                  style={{ cursor: "pointer" }}
                  className="clickable-hover"
                  onClick={() =>
                    onDownloadFile(
                      item?.attachmentName,
                      "StratagicA3",
                      "Results"
                    )
                  }
                >
                  {" "}
                  {item?.attachmentName}{" "}
                </a>
                <span className="rca_download">
                  <i
                    title="Download"
                    className="fa fa-download pointer"
                    // onClick={() =>
                    //   onDownloadFile(
                    //     item?.attachmentName,
                    //     "RPS",
                    //     "Breakdown"
                    //   )
                    // }
                  ></i>
                </span>
                <span
                  className="rca_delete"
                  style={{ padding: "0px 15px 0px 10px" }}
                >
                  <i
                    title="Delete"
                    className="fas fa-trash pointer"
                    onClick={() => deleteFile(item.id, item.attachmentName)}
                  ></i>
                </span>
              </div>
            ))}
        </div>
      </ScrollView>
    </>
  );
};
export default ConfirmedResult;
